import { selectCssVariables, cssVariables } from '../../../redux/cssVariablesSlice';
import { customFonts as customFontsSelector } from '../../../redux/customFontsSlice';
import {
	Flex,
	Box,
	AccordionButton,
	AccordionItem,
	AccordionIcon,
	AccordionPanel,
	Text,
	FormControl,
	FormLabel,
	Select,
} from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';

const typographyVariables = ['--main-font', '--main-font-2'];

const CssEditorFontSelector = () => {
	const cssVar = useSelector(cssVariables);
	const customFonts = useSelector(customFontsSelector);
	const dispatch = useDispatch();

	function updateFontValue(evt, key) {
		const value = evt.target.value;
		const newCssGlobalVar = { ...cssVar };
		newCssGlobalVar[key] = value;
		dispatch(selectCssVariables(newCssGlobalVar));
	}

	if (!cssVar || !customFonts) return null;

	return (
		<AccordionItem>
			<AccordionButton justifyContent={'space-between'}>
				<Text>Fontes</Text>
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel>
				<Box p={2} overflow={'visible'}>
					<Flex flexDir="row" flexWrap={'wrap'} sx={{ gap: '1px' }} overflow={'auto'} justifyContent={'space-between'}>
						{typographyVariables.map((key) => (
							<Box key={`typography-${key}`}>
								<Text
									borderBottom={'1px solid'}
									mr={0}
									borderColor={'gray.200'}
									fontFamily={'Poppins'}
									color={'gray.700'}
									fontWeight="bold"
									fontSize={'md'}
								>
									{key}
								</Text>
								<FormControl minW={'350px'}>
									<Select defaultValue={cssVar[key]} onChange={(evt) => updateFontValue(evt, key)}>
										{customFonts.map((fontFamily, index) => (
											<option key={`${fontFamily.font}-option-${index}`} value={fontFamily.font}>
												{fontFamily.font}
											</option>
										))}
									</Select>
								</FormControl>
							</Box>
						))}
					</Flex>
				</Box>
			</AccordionPanel>
		</AccordionItem>
	);
};

export default CssEditorFontSelector;
